import KVideoPlayer from '@/blocks/k-video-player'
import KVideoViewer from '@/blocks/k-video-viewer'
import KPromoReel from '@/blocks/k-promo-reel'

export const heros = {
  'video-full': {
    component: KVideoPlayer,
    meta: {
      collection: false,
      fullscreen: true,
      bg: true,
    }
  },
  'video-preview': {
    component: KVideoViewer,
    meta: {
      collection: false,
      fullscreen: true,
      bg: true,
    }
  },
  'promo-reel': {
    component: KPromoReel,
    meta: {
      collection: true,
      fullscreen: true,
      bg: true,
    }
  },
  plain: {
    component: 'div',
    meta: {
      collection: false,
      fullscreen: false,
      bg: true,
    }
  },
  blank: {
    component: 'div',
    meta: {
      collection: false,
      fullscreen: false,
      bg: false,
    }
  },
  default: {
    component: 'div',
    meta: {
      collection: false,
      fullscreen: true,
      bg: false,
    }
  },
}

export const components = {
  KVideoPlayer,
  KVideoViewer,
  KPromoReel,
}

export default heros
